import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';
import { ShFieldLabelComponent } from '../../../../../form-controls/components/_core/field-label/field-label.component';
import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { ShSearchRoutingService } from '../../../../services/search-routing.service';
import { ShSimpleReadonlyFieldComponent } from '../simple-readonly-field/simple-readonly-field.component';

@Component({
    standalone: false,
    selector: 'sh-long-readonly-field',
    templateUrl: '../simple-readonly-field/simple-readonly-field.component.html',
    styleUrls: ['../../base-generic-readonly-field/base-generic-readonly-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShLongReadonlyFieldComponent extends ShSimpleReadonlyFieldComponent {
    constructor(
        protected fieldHelper: FieldReadHelper,
        protected searchRoutingService: ShSearchRoutingService
    ) {
        super(fieldHelper, searchRoutingService);
    }

    init(profileField: ExtendedBaseProfileField, record: PartialRecord): void {
        this.value$.next(this.fieldHelper.getLongFieldValue(profileField.FieldDefinition, record));
    }
}
